/* eslint-disable no-mixed-spaces-and-tabs */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';

export const FIELD_TYPES = [
	'AuthorisedRep',
	'SalesTeam',
	'ServiceTeam',
	'Branch',
	'PermissionsGroup',
];

// Creating an API service using RTK Query
export const insightFieldsApi = createApi({
	reducerPath: 'insightFieldsApi',
	tagTypes: ['INSIGHT_FIELDS', 'INSIGHT_FIELD'],
	baseQuery: fetchBaseQuery({ ...BASE_QUERY, baseUrl: process.env.REACT_APP_MISC_API_ENDPOINT }),
	endpoints: (builder) => ({
		getInsightField: builder.query({
			providesTags: (result, error, docId) => [{ type: 'INSIGHT_FIELD', id: docId }],
			query: ({ docId, fieldType }) => ({
				url: `/insightFields/${fieldType}/get`,
				method: 'POST',
				body: {
					docId,
				},
			}),
			transformResponse: (response) => {
				console.log('👾 ~ transform /get response', response);
				return response;
			},
			transformErrorResponse: (response) => {
				console.log('👾 ~ transform /get response', response);
				return response;
			},
		}),
		listInsightFields: builder.query({
			providesTags: (result, error, { brokerGroupId, fieldType }) => [
				{ type: 'INSIGHT_FIELDS', id: `${brokerGroupId}-${fieldType}` },
			],
			query: ({ includeInactive = false, fieldType, brokerGroupId } = {}) => ({
				url: `/insightFields/${fieldType}/list`,
				method: 'POST',
				body: {
					includeInactive,
				},
			}),
			transformResponse: (response, meta) => {
				console.log('👾 ~ transform listInsightFields /list response', { response, meta });
				return response?.data?.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
				// return response?.data;
			},
		}),
	}),
});

// Exporting auto-generated hooks for the defined endpoints
export const { useListInsightFieldsQuery, useGetInsightFieldQuery } = insightFieldsApi;
